import {
  AddIcCall,
  ExpandMore,
  Payment,
  RecordVoiceOver,
} from "@mui/icons-material";
import MenuItemMui from "@mui/material/MenuItem";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Divider,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { setPostPayload } from "../../services/api";

const JobRequestPaymentUtils = ({
  colors,
  isNonMobile,
  id,
  year,
  regDate,
  project,
  institute,
  contactNo,
  contactPerson,
  email,
  grandTotal,
  setOpen,
  setMessage,
  setMessageType,
  data,
  labTests,
  setLoading,
  loading,
  balance,
  setSave,
}) => {
  const [currentRequest, setCurrentRequest] = useState({
    paymentMethod: {
      paymentMethod: "",
      error: false,
    },
    regDate: {
      regDate: dayjs(new Date()),
      error: false,
    },
    remark: "",
    amount: {
      amount: "",
      error: false,
    },
  });

  const paymentMethodArray = [
    {
      value: "Cash",
      label: "Cash",
    },
    {
      value: "Bank Transfer",
      label: "Bank Transfer",
    },
    {
      value: "Deposit",
      label: "Deposit",
    },
  ];
  const handleMakePayment = (e) => {
    if (currentRequest.paymentMethod.paymentMethod === "") {
      setCurrentRequest((pre) => ({
        ...pre,
        paymentMethod: {
          ...pre.paymentMethod,
          error: true,
        },
      }));
    } else if (currentRequest.regDate.regDate === "") {
      setCurrentRequest((pre) => ({
        ...pre,
        regDate: {
          ...pre.regDate,
          error: true,
        },
      }));
    } else if (
      currentRequest.amount.amount === "" ||
      currentRequest.amount.amount === 0
    ) {
      setCurrentRequest((pre) => ({
        ...pre,
        amount: {
          ...pre.amount,
          error: true,
        },
      }));
    } else if (currentRequest.amount.amount > balance) {
      setCurrentRequest((pre) => ({
        ...pre,
        amount: {
          ...pre.amount,
          error: true,
        },
      }));
      alert("Entered amount is greater than balance amount..!");
    } else {
      setCurrentRequest((pre) => ({
        ...pre,
        paymentMethod: {
          ...pre.paymentMethod,
          error: false,
        },
        regDate: {
          ...pre.regDate,
          error: false,
        },
        amount: {
          ...pre.amount,
          error: false,
        },
      }));
      // console.log("current req", currentRequest);
      handleSavePayment();
    }
  };

  const handleSavePayment = async () => {
    setLoading(true);
    const saveObj = {
      paymentMethod: currentRequest.paymentMethod.paymentMethod,
      paymentDate: currentRequest.regDate.regDate,
      payment: currentRequest.amount.amount,
      remark: currentRequest.remark,
      labRequest: { id: data.id },
    };

    console.log("sage", saveObj);

    await setPostPayload
      .setPayloadData("/labPayment", saveObj)
      .then(function (response) {
        // console.log(response.data);
        setSave((pre) => (pre === true ? false : true));
        setMessage(
          "Job : " +
            data.year +
            "/" +
            String(data.autoIdByYear).padStart(4, "0") +
            "" +
            " payment saved successfully..!"
        );
        setLoading(false);
        setMessageType("success");
        setOpen(true);
        setCurrentRequest((pre) => ({
          paymentMethod: {
            paymentMethod: "",
            error: false,
          },
          regDate: {
            regDate: dayjs(new Date()),
            error: false,
          },
          remark: "",
          amount: {
            amount: "",
            error: false,
          },
        }));
      })
      .catch(function (error) {
        console.log(error);
        // setLoading(false);
      });
  };

  const handlePaymentMethod = (e) => {
    setCurrentRequest((pre) => ({
      ...pre,
      paymentMethod: {
        ...pre.paymentMethod,
        paymentMethod: e.target.value,
      },
    }));
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Box flexGrow={1} display="flex" justifyContent="space-between">
          <Typography variant="h5" color="success">
            JOB/{year + "/" + String(data.autoIdByYear).padStart(4, "0")}
          </Typography>
          <Typography variant="h5" color="warning" marginRight={"20px"}>
            LKR{" "}
            {grandTotal.toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Card
          variant="elevation"
          elevation={3}
          sx={{
            width: "100%",
            marginBottom: "25px",
          }}
        >
          <CardContent style={{ paddingBottom: "2px" }}>
            <Box
              display="grid"
              gap="8px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 4",
                },
              }}
            >
              <Box
                sx={{
                  gridColumn: "span 5",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ width: "100%" }}
                >
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="h3" color="success">
                      Project
                    </Typography>
                    <Typography variant="h3" color="success">
                      JOB/
                      {year + "/" + String(data.autoIdByYear).padStart(4, "0")}
                    </Typography>
                  </Box>
                  <Typography variant="h3" color={colors.grey[500]}>
                    {project}
                  </Typography>
                </Box>
              </Box>
              <Divider sx={{ gridColumn: "span 5" }} />
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Job register date</Typography>
                <Typography variant="h5" color="success">
                  {regDate}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Institute</Typography>
                <Typography variant="h5" color="success">
                  {institute}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Contact No</Typography>
                <Typography variant="h5" color="success">
                  {contactNo}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Email</Typography>
                <Typography variant="h5" color="success">
                  {email}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h3" color="success" fontWeight={550}>
                  LKR{" "}
                  {grandTotal.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </Typography>
              </Box>
              <Divider sx={{ gridColumn: "span 5" }}>
                <Chip label="JOB RELATED TESTS" size="medium" />
              </Divider>

              <Box sx={{ gridColumn: "span 5", padding: "10px" }}>
                <Box
                  display="grid"
                  gap={2}
                  gridTemplateColumns="repeat(5, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 5",
                    },
                  }}
                >
                  <Typography
                    sx={{ gridColumn: "span 2" }}
                    color="info"
                    variant="h5"
                  >
                    Lab Test Name
                  </Typography>
                  <Typography
                    sx={{ gridColumn: "span 1" }}
                    color="info"
                    variant="h5"
                  >
                    Quantity
                  </Typography>
                  <Typography
                    sx={{ gridColumn: "span 1" }}
                    color="info"
                    variant="h5"
                    textAlign="right"
                    marginRight="10px"
                  >
                    Amount
                  </Typography>
                  <Typography
                    sx={{ gridColumn: "span 1" }}
                    color="info"
                    variant="h5"
                    textAlign="right"
                    marginRight="10px"
                  >
                    Total
                  </Typography>
                </Box>
              </Box>

              {labTests.map((data, index) => (
                <Paper
                  key={index}
                  variant="outlined"
                  sx={{ padding: "10px", width: "100%", gridColumn: "span 5" }}
                >
                  <Box
                    display="grid"
                    gap={2}
                    gridTemplateColumns="repeat(5, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 5",
                      },
                    }}
                  >
                    <Typography variant="h5" sx={{ gridColumn: "span 2" }}>
                      {data.labTest.testName}
                    </Typography>
                    <Typography variant="h5" sx={{ gridColumn: "span 1" }}>
                      {data.quantity.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}{" "}
                      Nos
                    </Typography>
                    <Typography
                      variant="h5"
                      textAlign="right"
                      marginRight="10px"
                      sx={{ gridColumn: "span 1" }}
                    >
                      {data.labTest.amount.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ gridColumn: "span 1" }}
                      textAlign="right"
                      marginRight="10px"
                    >
                      {data.total.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </Typography>
                  </Box>
                </Paper>
              ))}

              <Divider sx={{ gridColumn: "span 5" }} />
              <Typography
                textAlign="right"
                variant="h4"
                color={colors.grey[500]}
                sx={{ gridColumn: "span 5", paddingRight: "20px" }}
              >
                TOTAL{" : "}
                {grandTotal.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })}
              </Typography>
              <Box
                display="flex"
                sx={{ gridColumn: "span 5" }}
                justifyContent="space-between"
              >
                <Typography
                  textAlign="right"
                  variant="h4"
                  color="success"
                  sx={{ gridColumn: "span 5", paddingRight: "20px" }}
                >
                  ADVANCE PAYMENT{" : "}
                  {(grandTotal - balance).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </Typography>
                <Typography
                  textAlign="right"
                  variant="h4"
                  color="error"
                  sx={{ gridColumn: "span 5", paddingRight: "20px" }}
                >
                  DUE AMOUNT{" : "}
                  {balance.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </Typography>
              </Box>
              <Divider sx={{ gridColumn: "span 5" }} />
              <Box sx={{ gridColumn: "span 5" }}>
                <Box
                  display="grid"
                  gap={0.5}
                  gridTemplateColumns="repeat(5, minmax(0, 1fr))"
                >
                  <TextField
                    select
                    label="Payment Method"
                    size="small"
                    error={currentRequest.paymentMethod.error}
                    value={currentRequest.paymentMethod.paymentMethod}
                    onChange={handlePaymentMethod}
                    sx={{
                      marginTop: "7px",
                      gridColumn: "span 1",
                    }}
                  >
                    {paymentMethodArray?.map((option) => (
                      <MenuItemMui key={option.value} value={option.value}>
                        {option.label}
                      </MenuItemMui>
                    ))}
                  </TextField>
                  <Box sx={{ gridColumn: "span 1" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          label="Payment Date"
                          format="YYYY-MM-DD"
                          sx={{ width: "100%" }}
                          error={currentRequest.regDate.error}
                          value={currentRequest.regDate.regDate}
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                            },
                          }}
                          onChange={(newVal) =>
                            setCurrentRequest((pre) => ({
                              ...pre,
                              regDate: {
                                ...pre.regDate,
                                regDate: newVal,
                              },
                            }))
                          }
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Box>
                  <TextField
                    label="Amount"
                    size="small"
                    type="number"
                    value={currentRequest.amount.amount}
                    defaultValue=""
                    onChange={(e) => {
                      setCurrentRequest((pre) => ({
                        ...pre,
                        amount: {
                          ...pre.amount,
                          amount: e.target.value,
                        },
                      }));
                    }}
                    sx={{ marginTop: "8px", gridColumn: "span 1" }}
                  />
                  <TextField
                    label="Remark"
                    size="small"
                    defaultValue=""
                    value={currentRequest.remark}
                    onChange={(e) => {
                      setCurrentRequest((pre) => ({
                        ...pre,
                        remark: e.target.value,
                      }));
                    }}
                    sx={{ marginTop: "8px", gridColumn: "span 2" }}
                  />
                </Box>
              </Box>
            </Box>
          </CardContent>
          <Divider sx={{ marginTop: "5px" }} />
          <CardActions
            sx={{
              margin: 0,
              paddingTop: "0px",
              paddingBottom: "0px",
              justifyContent: "space-between",
            }}
          >
            <Box display="flex" alignItems="center">
              <AddIcCall color="warning" />
              <Typography
                sx={{ marginLeft: "5px" }}
                variant="h5"
                color="success"
              >
                Contact No : {`${contactNo}`}
              </Typography>
              <RecordVoiceOver sx={{ marginLeft: "25px" }} color="warning" />
              <Typography
                sx={{ marginLeft: "5px" }}
                variant="h5"
                color="success"
              >
                Contact Person : {contactPerson}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center">
              <Button
                type="button"
                startIcon={<Payment />}
                color="success"
                loading={loading}
                variant="contained"
                onClick={handleMakePayment}
                sx={{ margin: "5px 0 5px 0" }}
              >
                MAKE PAYMENT
              </Button>
            </Box>
          </CardActions>
        </Card>
      </AccordionDetails>
    </Accordion>
  );
};
export default JobRequestPaymentUtils;
